/**支付费用**/
<template>
  <div class="Settlement">
    <div class="Settlementcont">
      <div class="feiyong">
        <div class="title">
          <h2>支付费用</h2>
          <div class="line"></div>
        </div>
        <div class="content">
        <span class="sum">
          <span class="daxie">{{DJOrderFee&&DJOrderFee.real_pay ? DJOrderFee.real_pay.toFixed(1): 0}}</span>
          <!--<span class="xsd">.</span>-->
          <!--<span class="xiaoye">{{DJOrderFee&&DJOrderFee.real_pay ? DJOrderFee.real_pay.toFixed(1).split('.')[1] : '0'}}</span>-->
          <!--<span class="danwei">元</span>-->
        </span>
        </div>
      </div>
      <div class="detailed">
        <span @click="detailsBoxFn">费用详情<i class="iconfont  icon-iconfontyiwen"></i></span>
      </div>
      <div class="payType">
        <div class="title">
          <h2>支付方式</h2>
          <div class="line"></div>
        </div>
        <div class="payTypeContent">
          <ul>
            <!--v-if="(postCustomerPreSave.present_balance||0)>(DJOrderFee&&DJOrderFee.total_fee||0)"-->
            <li @click="payTypeFn(1)">
              <span>
                <i class="iconfont icon-yue Icon"></i>
                余额支付
                <span class="select " :class="data.payType==1?'selectAction':''">
                  <i class="iconfont icon-chenggong "></i>
                </span>
              </span>
            </li>
            <li @click="payTypeFn(2)" v-if="wxState">
            <span>
            <i class="iconfont icon-weixin Icon"></i>
            微信支付
            <span class="select" :class="data.payType==2?'selectAction':''">
            <i class="iconfont icon-chenggong "></i>
            </span>
            </span>
            </li>
            <li @click="payTypeFn(3)" v-if="loginData.passenger && loginData.passenger.allowOverdraw">
              <span>
                <i class="iconfont icon-qiandan-copy Icon"></i>
                签单支付
                <span class="select" :class="data.payType==3?'selectAction':''">
                  <i class="iconfont icon-chenggong "></i>
                </span>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div class="submitBut" @click="payFn">
        <span>立即支付</span>
      </div>
    </div>
    <Xk-detailsBox :title="'费用详情'" class="costBox" ref="detailsBox">
      <div slot="content">
        <ul>
          <!--<li class="clear">-->
          <!--<span class="name">预算金额</span>-->
          <!--<span class="val"><span class="sum">{{DJOrderFee&&DJOrderFee.budget_fee||0}}</span><span-->
          <!--class="unit">元</span></span>-->
          <!--&lt;!&ndash;<span class="time">({{budgetFee&&budgetFee.time}}<span class="unit">分钟)</span></span>&ndash;&gt;-->
          <!--&lt;!&ndash;<span class="time">({{DJOrderFee&&DJOrderFee.distance||0}}<span&ndash;&gt;-->
          <!--&lt;!&ndash;class="unit">公里)</span></span>&ndash;&gt;-->
          <!--</li>-->
          <li class="clear" v-for="item in orderFeeDetail">
            <span class="name">{{item.name}}</span>
            <span class="val"><span class="sum">{{item.cost}}</span><span
              class="unit">元</span></span>
          </li>
        </ul>
      </div>
    </Xk-detailsBox>
    <xk-upload-mod :state="loadState"></xk-upload-mod>
    <xk-hint-box v-if="hintBox.stateShow" :state="hintBox.state" :content="hintBox.content"></xk-hint-box>
  </div>
</template>

<script>
  import wx from 'weixin-js-sdk'
  import XkdetailsBox from '../../module/detailsBox/src/detailsBox.vue'
  import {mapGetters} from 'vuex'
  import XkUploadMod from '../../module/uploadMod/src/uploadMod'
  import XkHintBox from '../../module/hintBox/src/hintBox'

  export default {
    components: {
      XkHintBox,
      XkUploadMod
    },
    component: {
      XkdetailsBox
    },
    name: 'Settlement',
    computed: {
      ...mapGetters({
        DjPayInfo: 'DjPayInfo',
        loginData: 'loginData',
        DJOrderFee: 'DJOrderFee',
        wxState: 'wxState',
        postCustomerPreSave: 'postCustomerPreSave',
        DjOrderInfo: 'DjOrderInfo'
      }),
      orderFeeDetail () {
        let DJOrderFee = this.DJOrderFee
        let arr = []
        let obj = {name: '', cost: ''}
        console.log('DJOrderFee', DJOrderFee)
        if (DJOrderFee && DJOrderFee.start_price) {
          obj = {
            name: '起步费',
            cost: DJOrderFee.start_price
          }
          arr.push(obj)
        }
        if (DJOrderFee && DJOrderFee.cross_fee) {
          obj = {
            name: '垫付费',
            cost: DJOrderFee.cross_fee
          }
          arr.push(obj)
        }
        if (DJOrderFee) {
          let otherCost = DJOrderFee.total_fee - (DJOrderFee.start_price ? DJOrderFee.start_price : 0) - (DJOrderFee.cross_fee ? DJOrderFee.cross_fee : 0)
          let cost = Math.round(otherCost * 10) / 10
          obj = {
            name: '其他费用',
            cost: cost
          }
          arr.push(obj)
        }
        if (DJOrderFee && DJOrderFee.total_fee) {
          obj = {
            name: '订单总金额',
            cost: DJOrderFee.total_fee
          }
          arr.push(obj)
        }
        if (DJOrderFee && DJOrderFee.enterprise_member_deduction) {
          obj = {
            name: '企业优惠抵扣',
            cost: DJOrderFee.enterprise_member_deduction
          }
          arr.push(obj)
        }
        if (DJOrderFee && DJOrderFee.coupon_fee) {
          obj = {
            name: '优惠券金额',
            cost: DJOrderFee.coupon_fee
          }
          arr.push(obj)
        }
        if (DJOrderFee && DJOrderFee.min_cost) {
          obj = {
            name: '最低消费',
            cost: DJOrderFee.min_cost
          }
          arr.push(obj)
        }
        return arr
      }
    },
    data () {
      return {
        data: {
          costDetail: [], // 费用详情
          payType: 1 // 支付方式
        },
        orderId: '', // 订单id
        loadState: false,
        hintBox: {
          stateShow: false,
          state: 'yes',
          content: ''
        }
      }
    },
    watch: {
      DjOrderInfo (val) {
        let that = this
        console.log('valxxxxxxxxxxxxxxxxxxx', val)
        if (that.loginData.passenger && val && that.loginData.passenger.id !== val.passenger_id) {
          that.$router.push('/daijia')
          return
        }
        switch (val.status) {
          case 1:
            this.$router.push({path: '/daijia/await', query: {order_id: this.orderId}})
            break
          case 5:
            this.$router.push({path: '/daijia/await', query: {order_id: this.orderId}})
            break
          case 10:
            this.$router.push({path: '/daijia/service', query: {order_id: this.orderId}})
            break
          case 15:
            this.$router.push({path: '/daijia/service', query: {order_id: this.orderId}})
            break
          case 20:
            this.$router.push({path: '/daijia/service', query: {order_id: this.orderId}})
            break
          case 25:
            this.$router.push({path: '/daijia/service', query: {order_id: this.orderId}})
            break
          case 30:
            setTimeout(function () {
              if (that.$route.fullPath.split('?')[0] === '/daijia/settlement') {
                that.$store.dispatch('DjOrderInfo', {order_id: that.$route.query.order_id})
              }
            }, 3000)
            break
          case 35:
            this.$router.push({path: '/daijia/affirm', query: {order_id: this.orderId}})
            break
          case 40:
            this.$router.replace('/')
            break
          case 45:
            this.$router.replace('/')
            break
        }
        // if (val.status === 30) {
        //   setTimeout(function () {
        //     if (that.$route.fullPath.split('?')[0] === '/daijia/settlement') {
        //       that.$store.dispatch('DjOrderInfo', {order_id: that.$route.query.order_id})
        //     }
        //   }, 3000)
        // } else if (val.status === 35) {
        //   that.$router.replace({path: '/daijia/affirm', query: {order_id: that.$route.query.order_id}})
        // } else if (val.status === 40 || val.status === 45) {
        //   this.$router.replace('/')
        // }
      }
    },
    methods: {
      detailsBoxFn: function () { // 详情事件
        this.$refs.detailsBox.switchFn()
      },
      payTypeFn: function (val) { // 支付方式事件
        let that = this
        switch (val) {
          case 1:
            that.data.payType = 1
            break
          case 2:
            that.data.payType = 2
            break
          case 3:
            that.data.payType = 3
            break
        }
      },
      payFn: function () {
        let state = this.data.payType
        let that = this
        that.loadState = true
        if (state === 1 || state === 3) {
          let payType = state === 1 ? 'balance' : state === 3 ? 'sign' : ''
          console.log('1-1')
          that.$store.dispatch('DjBalancePay', {
            'id': that.$route.query.order_id,
            'who': 'member',
            'timeStamp': Date.parse(new Date()) / 1000,
            'pay_type': payType,
            fn: (data) => {
              that.loadState = false
              if (data && data.code === 1) {
                that.hintBox = {
                  stateShow: true,
                  state: 'yes',
                  content: '支付成功！'
                }
                setTimeout(() => {
                  that.hintBox.stateShow = false
                  that.$router.push({path: '/daijia/affirm', query: {order_id: that.$route.query.order_id}})
                }, 1500)
              }
              if (data.code === 20088) {
                that.hintBox = {
                  stateShow: true,
                  state: 'no',
                  content: '余额不足'
                }
                setTimeout(() => {
                  that.hintBox.stateShow = false
                }, 1500)
              }
            }
          })
        }
        if (state === 2) {
          console.log('1-2')
          that.$store.dispatch('DjBalancePay', {
            'id': that.$route.query.order_id,
            'open_id': window.configure.open_id,
            'who': 'member',
            'timeStamp': Date.parse(new Date()) / 1000,
            'pay_type': 'weixin',
            fn: (data) => {
              that.loadState = false
              if (data && data.code === 1) {
                let content = data.weixinResult
                wx.config({
                  debug: false,
                  appId: window.configure.WXappId,
                  timeStamp: content.wx_app_ts,
                  nonceStr: content.wx_app_nonce,
                  signature: content.wx_app_sign,
                  jsApiList: ['chooseWXPay']
                })

                wx.ready(function () {
                  wx.chooseWXPay({
                    timestamp: content.wx_app_ts,
                    nonceStr: content.wx_app_nonce,
                    package: content.wx_app_pkg,
                    signType: content.wx_app_sign_type,
                    paySign: content.wx_app_sign,
                    success: function (res) {
                      if (data && data.code === 1) {
                        that.hintBox = {
                          stateShow: true,
                          state: 'yes',
                          content: '支付成功！'
                        }
                        setTimeout(() => {
                          that.hintBox.stateShow = false
                          that.$router.push({path: '/daijia/affirm', query: {order_id: that.$route.query.order_id}})
                        }, 1500)
                      }
                    }
                  })
                })
                // this.hintBox = {
                //   stateShow: true,
                //   state: 'yes',
                //   content: '支付成功！'
                // }
                // setTimeout(() => {
                //   this.hintBox.stateShow = false
                //   that.$router.push({path: '/daijia/affirm', query: {order_id: that.$route.query.order_id}})
                // }, 1500)
              }
            }
          })
          // that.$store.dispatch('DjWXPay', {
          //   'orderId': that.$route.query.order_id,
          //   'openid': that.loginData.openId,
          //   'WXappId': window.configure.WXappId,
          //   fn: function (data) {
          //     that.loadState = false
          //     if (data === '支付成功') {
          //       that.hintBox = {
          //         stateShow: true,
          //         state: 'yes',
          //         content: '支付成功！'
          //       }
          //       setTimeout(() => {
          //         that.hintBox.stateShow = false
          //         that.$store.dispatch('unfilledOrderState', {type: 'daijia', state: false})
          //         that.$router.push({path: '/daijia/affirm', query: {order_id: that.$route.query.order_id}})
          //       }, 1500)
          //     } else {
          //       that.hintBox = {
          //         stateShow: true,
          //         state: 'yes',
          //         content: '支付失败！'
          //       }
          //       setTimeout(() => {
          //         that.hintBox.stateShow = false
          //       }, 1500)
          //     }
          //   }
          // })
        }
      }
    },
    mounted: function () {
      let that = this
      this.orderId = this.$route.query.order_id
      that.$store.dispatch('checkLogin', (state) => {
        if (state) {
          that.$store.dispatch('DjPayInfo', {order_id: that.$route.query.order_id})
          that.$store.dispatch('DjOrderInfo', {order_id: that.$route.query.order_id})
          that.$store.dispatch('postCustomerPreSave', {
            id: that.loginData.passenger.id
          })
        }
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .Settlement {
    .Settlementcont {
      width: 100vw;
      height: 100vh;
      overflow: hidden;
      overflow-y: auto;
      box-sizing: border-box;
      background-color: #f3f4f5;
      padding: 1rem;
    }
    .title {
      height: 1.5rem;
      line-height: 1.5rem;
      text-align: center;
      position: relative;
      h2 {
        display: inline-block;
        color: #333;
        font-size: 1.6rem;
        padding: 0 0.8rem;
        background-color: #fff;
        z-index: 10;
        position: relative;
      }
      .line {
        width: 100%;
        height: 1px;
        background-color: #eee;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .feiyong {
      background-color: #fff;
      padding: 1rem;
      padding-top: 1.5rem;
      padding-bottom: 1rem;
      .content {
        text-align: center;
        padding-top: 1.8rem;
        .sum {
          color: #f06553;
          .xiaoye, .danwei {
            font-size: 1.5rem;
          }
          .daxie {
            font-size: 3rem;
          }
        }
      }
    }
    .detailed {
      background-color: #fff;
      text-align: center;
      line-height: 1.5rem;
      height: 1.5rem;
      color: #999999;
      padding: 0.5rem 0 1.8rem 0;
      font-size: 1rem;
      span {
        display: inline-block;
        i {
          font-size: 1.3rem;
          padding-left: 0.3rem;
          color: #999999;
        }
      }

    }
    .payType {
      background-color: #fff;
      margin-top: 1rem;
      padding: 1rem;
      padding-top: 1.5rem;
      .payTypeContent {
        padding-top: 1rem;
        ul {
          width: 100%;
          li {
            box-sizing: border-box;
            line-height: 3.6666rem;
            height: 3.6666rem;
            font-size: 1.3rem;
            color: #434343;
            width: 100%;
            position: relative;
            padding: 0 1rem;
            > span {
              width: 100%;
            }
            i {
              font-size: 1.5rem;
            }
            .Icon {
              margin-right: 0.5rem;
            }
            .select {
              display: inline-block;
              width: 1.8rem;
              height: 1.8rem;
              box-sizing: border-box;
              overflow: hidden;
              border-radius: 50%;
              border: 1px solid #cccccc;
              position: absolute;
              right: 1.1666rem;
              top: 50%;
              transform: translate(0, -50%);
              transition: 0.3s all;
              i {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                font-size: 0.3rem;
                opacity: 0;
                color: #fff;
                transition: 0.3s all;
              }
            }
            .selectAction {
              background-color: #f06553;
              border-color: #f06553;
              i {
                opacity: 1;
              }
            }
          }
          .icon-yue {
            color: #fe5459;
          }
          .icon-weixin {
            color: #00c801;
          }
          .icon-qiandan-copy {
            color: #ffb400;
          }
        }
      }
    }
    .submitBut {
      box-sizing: border-box;
      width: 100%;
      margin-top: 1rem;
      margin-bottom: 1rem;
      span {
        width: 100%;
        line-height: 3.666rem;
        height: 3.666rem;
        border-radius: 0.333rem;
        background-color: #f06553;
        text-align: center;
        color: #fff;
        font-size: 1.4rem;
      }
    }
    .costBox {
      ul {
        li {
          height: 2rem;
          line-height: 2rem;
          color: #999999;
          .name {
            float: left;
          }
          .time, .val {
            float: right;
          }
          .time {
            margin-right: 0.8rem;
            color: #333333;
          }
          .sum {
            color: #f06553;
          }
          .unit {
            margin-left: 0.3rem;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// settlement.vue?101b9977